<div
class="hide-overflow"
[ngClass]="{'overflow': !opened}"
[ngStyle]="{'max-height': heightInPixel, 'transition':  'max-height 0.25s ease-in-out' }"
#content>
<ng-content>

</ng-content>
</div>
<div
*ngIf="content.offsetHeight < content.scrollHeight || content.scrollHeight > maxHeightPx"
class="editorial-actions-block">
<span
[ngClass]="{'__open':content.style['max-height']==(content.scrollHeight + 10).toString()  + 'px', '__close':content.style['max-height']==heightInPixel}"
(click)="content.offsetHeight < content.scrollHeight ?
expand(content):
content.style['max-height']=heightInPixel; scroll(content); close()
"
>{{
  content.style['max-height'] === (content.scrollHeight + 10).toString()  + 'px' ? ('see_less' | transloco)
  : ('see_more' | transloco)
}}
<div class="arrow"></div>
</span>

</div>
